"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var ScreenSizes;
/**
 * Retorna a tag correspondente a largura da tela do dispositivo
 * ```js
 * {
 *  xs: '<576px',
 *  sm: '≥576px',
 *  md: '≥768px',
 *  lg: '≥992px',
 *  xl: '≥1200px',
 *  xxl: '≥1400px'
 * }
 * ```
 */

(function (ScreenSizes) {
  ScreenSizes[ScreenSizes["xxl"] = 1400] = "xxl";
  ScreenSizes[ScreenSizes["xl"] = 1200] = "xl";
  ScreenSizes[ScreenSizes["lg"] = 992] = "lg";
  ScreenSizes[ScreenSizes["md"] = 768] = "md";
  ScreenSizes[ScreenSizes["sm"] = 576] = "sm";
})(ScreenSizes || (ScreenSizes = {}));

const getScreenSizeClassification = () => {
  if (window.innerWidth >= ScreenSizes.xxl) return 'xxl';
  if (window.innerWidth >= ScreenSizes.xl) return 'xl';
  if (window.innerWidth >= ScreenSizes.lg) return 'lg';
  if (window.innerWidth >= ScreenSizes.md) return 'md';
  if (window.innerWidth >= ScreenSizes.sm) return 'sm';
  return 'xs';
};

var _default = getScreenSizeClassification;
exports.default = _default;